export const Delete = () => (
    <>
        <path
            d="M10.75 10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V17C9.25 17.4142 9.58579 17.75 10 17.75C10.4142 17.75 10.75 17.4142 10.75 17V10Z"
            fill="black"
        />
        <path
            d="M14 9.25C14.4142 9.25 14.75 9.58579 14.75 10V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V10C13.25 9.58579 13.5858 9.25 14 9.25Z"
            fill="black"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.32501 5.25C8.67247 3.53832 10.1858 2.25 12 2.25C13.8142 2.25 15.3275 3.53832 15.675 5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H19.6566L17.9748 19.3635C17.7926 20.7297 16.6272 21.75 15.2489 21.75H8.751C7.37269 21.75 6.20728 20.7297 6.02512 19.3635L4.34332 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H8.32501ZM9.87803 5.25C10.1869 4.37611 11.0203 3.75 12 3.75C12.9797 3.75 13.8131 4.37611 14.122 5.25H9.87803ZM7.51196 19.1652L5.8566 6.75H18.1433L16.488 19.1652C16.4052 19.7862 15.8754 20.25 15.2489 20.25H8.751C8.12449 20.25 7.59476 19.7862 7.51196 19.1652Z"
            fill="black"
        />
    </>
);

Delete.viewBox = `0 0 24 24`;
